/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Form, useForm } from '../../../applications/hooks/UseForm'
import { Grid } from '@mui/material'
import Controls from '../../../components/Entry/Controls'

const initialFValues = {
    // id: 0,
    title: '',
    code: ''
}

export const AddDataSets = (props) => {
    const { addOrEdit, recordForEdit } = props
    const [userHaveToPost, setUserHaveToPost] = useState(false)


    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        if ('code' in fieldValues) temp.code = fieldValues.code ? '' : 'Ce champ est requis.'
        if ('title' in fieldValues) temp.title = fieldValues.title ? '' : 'Ce champ est requis.'
        setErrors({
            ...temp
        })

        if (fieldValues === values) return Object.values(temp).every((x) => x === '')
    }

    const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(
        initialFValues,
        true,
        validate
    )

    const handleSubmit = (e) => {
        e.preventDefault()
        if (validate()) {
            addOrEdit(values, resetForm, setUserHaveToPost)
        }
    }

    useEffect(() => {
        if (recordForEdit != null)
            setValues({
                ...recordForEdit
            })
    }, [recordForEdit])

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
                <Grid item xs={12}>
                    <Controls.Input
                        name="title"
                        label="Titre"
                        value={values.title}
                        onChange={handleInputChange}
                        error={errors?.title}
                        isRequired={true}
                    />
                    <Controls.Input
                        name="code"
                        label="Code"
                        value={values.code}
                        onChange={handleInputChange}
                        error={errors?.code}
                        isRequired={true}
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center', marginTop: '8px' }}>
                    <Controls.Button type="submit" text="Enregistrer" haveSpin={true} disabled={userHaveToPost} />
                </Grid>
            </Grid>
        </Form>
    )
}
